/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unused-vars */
import { initiateEvaluationsStep } from './steps/evaluations/initiateEvaluationsStep';
import { initiateDiagnosticStep } from './steps/diagnostic/initiateDiagnosticStep';
import { initiateEvolutionsStep } from './steps/evolution/initiateEvolutionsStep';
import { initiateIndicationStep } from './steps/indication/initiateIndicationStep';
import { initiateInventoryStep } from './steps/inventory/initiateInventoryStep';
import { initiateProfessionalSignatureStep } from './steps/professionalSignature/initiateProfessionalSignatureStep';
import { initiatePrescriptionStep } from './steps/prescriptions/initiatePrescriptionsStep';
import { initiateReportProblemStep } from './steps/reportProblem/initiateReportProblemStep';

const TEMPLATE_NAME = 'PERFORM_VISIT_STEPS';

const stepBuild = {
  evaluations: initiateEvaluationsStep,
  diagnostic: initiateDiagnosticStep,
  prescriptions: initiatePrescriptionStep,
  indications: initiateIndicationStep,
  reportProblem: initiateReportProblemStep,
  transcriptionPrescriptions: () => {},
  professionalSignature: initiateProfessionalSignatureStep,
  evolutions: initiateEvolutionsStep, // etapa não necessária no sistema web
  inventories: initiateInventoryStep // etapa não necessária no sistema web
  // familySignatures: () => {}, // etapa não necessária no sistema web
  // prescriptionSchedules: () => {}, // etapa não necessária no sistema web// etapa não necessária no sistema web
  // sbarWrite: () => {}, // etapa não necessária no sistema web
  // sbarRead: () => {}, // etapa não necessária no sistema web
};

const createSteps = steps => {
  const nSteps = {};

  for (const key in steps) {
    if (!Object.keys(stepBuild).includes(key)) {
      throw new Error('Error: Unexpected property');
    }

    if (steps.hasOwnProperty(key)) {
      const step = steps[key];
      nSteps[key] = stepBuild[key](step);
    }
  }

  return nSteps;
};

const initialState = () => ({
  loadInProgress: false,
  loadFail: false,
  loadSuccess: false,
  loadedData: {
    visitInfo: {},
    visitSteps: {}
  },
  sendInProgress: false,
  sendFail: false,
  sendSuccess: false
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    // ==================================================
    //                LIST INFORMATION
    // ==================================================

    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loadInProgress: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loadFail: true,
        loadSuccess: false,
        loadInProgress: false
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const { patient, steps, visitInfo, visitSteps } = action.payload;

      const nSteps = createSteps(visitSteps);

      return {
        ...state,
        loadFail: false,
        loadSuccess: true,
        loadInProgress: false,
        loadedData: {
          visitInfo: { ...visitInfo },
          visitSteps: { ...nSteps }
        }
      };
    }

    // ==================================================
    //                SUBMIT INFORMATION
    // ==================================================
    case `${TEMPLATE_NAME}_SUBMIT_PENDING`: {
      return {
        ...state,
        sendInProgress: true
      };
    }

    case `${TEMPLATE_NAME}_SUBMIT_REJECTED`: {
      return {
        ...state,
        sendFail: true,
        sendSuccess: false,
        sendInProgress: false
      };
    }

    case `${TEMPLATE_NAME}_SUBMIT_FULFILLED`: {
      // const { payload } = action;

      return {
        ...state,
        sendFail: false,
        sendSuccess: true,
        sendInProgress: false
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
